/* eslint-disable @typescript-eslint/naming-convention */

import { SearchFilterOption } from "../../../shared/components/search-bar/search-filter/search-filter.component";
import { SearchInputOption } from "../../../shared/components/search-bar/search-input/search-input.component";
import { UserInfo } from "../../../shared/types/user-info";
import { ConfigurableOption } from "./configurable-options.type";

export const configurableOptionsTypes: SearchInputOption[] = [{ value: "sla", label: "SLA" }];

//#region Search Filter Options
export const getConfigurableOptionSearchFilterOptions = (
  _user: UserInfo,
  config?: {
    shown?: string[];
    hidden?: string[];
  },
): SearchFilterOption<ConfigurableOption>[] => {
  const { shown, hidden } = config || {};

  return (
    [
      {
        value: "type",
        label: "Type",
        inputType: "dropdown",
        options: [...configurableOptionsTypes],
        condition: "$eq",
      },
      { value: "value", label: "Value", disabled: false },
    ] as SearchFilterOption<ConfigurableOption>[]
  ).filter((opt) => (shown ? shown.includes(opt.value) : true) && (hidden ? !hidden.includes(opt.value) : true));
};
